import React from 'react';
import _ from 'lodash';
import Big from 'big.js';

import { useSelectItemsModalQuery } from 'generated/graphql';
import * as types from './types';



export interface IData {
  items: types.IItem[];
}

export function useQuery(storeId: string) {
  const tuple = useSelectItemsModalQuery({
    variables: {
      storeId,
      checkInventoryManagement: !!storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        items: _.map(tuple.data?.items.nodes ?? [], (node): types.IItem => ({
          id: node.id,
          disabled: !_.isNil(node.canManageInventory) && !node.canManageInventory,
          primaryText: node.name,
          secondaryText: `${node.sku} ${!_.isNil(node.canManageInventory) && !node.canManageInventory ? "(Cannot manage inventory)" : ''}`,
          itemId: node.id,
          defaultPriceDollars: new Big(node.defaultPriceDollars).toFixed(2)
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
